module.exports = __webpack_public_path__ + "img/Monte_Kope_112.82c23f02.jpg";